export const PIXELS_TO_REM_RATIO = 16; // REM is based on the font size of the root element (16px by default)
export const DEFAULT_EM_VALUE = 16;
export const DEFAULT_EM = `${DEFAULT_EM_VALUE}px`;
